import { Link } from "react-router-dom";
import logo from "@/assets/logo.jpeg";
import { MessageCircle, Mail } from "lucide-react";

const Footer = () => {
  return (
    <footer className="border-t border-gold-dark/20 bg-card/50 py-12">
      <div className="container mx-auto px-4">
        <div className="grid gap-8 md:grid-cols-4">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2">
              <img src={logo} alt="Prime Profit" className="h-10 w-auto rounded" />
              <span className="font-display text-base font-bold gradient-gold-text">PRIME PROFIT</span>
            </div>
            <p className="mt-3 text-xs text-muted-foreground font-body">
              Strategic BTC & BNB trading cycles delivering consistent returns.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-display text-sm font-semibold text-gold">Quick Links</h4>
            <ul className="mt-3 space-y-2 text-sm text-muted-foreground font-body">
              <li><Link to="/login" className="hover:text-gold transition-colors">Login</Link></li>
              <li><Link to="/register" className="hover:text-gold transition-colors">Register</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-display text-sm font-semibold text-gold">Legal</h4>
            <ul className="mt-3 space-y-2 text-sm text-muted-foreground font-body">
              <li><Link to="/terms" className="hover:text-gold transition-colors">Terms & Conditions</Link></li>
              <li><Link to="/privacy" className="hover:text-gold transition-colors">Privacy Policy</Link></li>
              <li><Link to="/disclaimer" className="hover:text-gold transition-colors">Risk Disclaimer</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-display text-sm font-semibold text-gold">Contact</h4>
            <ul className="mt-3 space-y-2 text-sm text-muted-foreground font-body">
              <li className="flex items-center gap-2">
                <Mail className="h-4 w-4 text-gold/70" />
                <a href="mailto:support@primechaincapital.com" className="hover:text-gold transition-colors">
                  support@primechaincapital.com
                </a>
              </li>
              <li className="flex items-center gap-2">
                <MessageCircle className="h-4 w-4 text-gold/70" />
                <a href="https://t.me/primechaincapital" target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors">
                  Telegram
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-gold-dark/20 pt-6 text-center">
          <p className="text-xs text-muted-foreground font-body">
            © 2023 PrimeProfits. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
